import React, { Component } from "react";
import Joi from "joi-browser";
import Form from "./../../common/form/form";
import SignUpLeftBar from "../common/signUpLeftBar";
import AlertSuccess from "../../common/alertSuccess";
import AlertError from "../../common/alertError";
import { doctorUpdate, getDoctor, loadDoctorProfile } from "../../../store/doctor";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { getDoctorToken } from "../../services/localStorageServices";
import SubmitBtn from "../../common/form/submitBtn";
import HelpText from "./helpText";
import FileInput from "../../common/form/fileInput";
import seUploadFun from "../../services/s3Services";

class SocialLinks extends Form {
    state = {
      btnClass: "btn btn-primary btn-lg",
      loading: false,
      data: {
        instagram: "",
        linkedin: "",
        video: "",
      },
      errors: {},
    };
  
    schema = {
      instagram: Joi.string().uri().allow(""),
      linkedin: Joi.string().uri().allow(""),
      video: Joi.string().allow(""), 
    };
  
    // Video Upload Function
    fileUploadVideo = (e) => {
      const _id = this.props.doctorProfile._id;
      const file = e.target.files[0];
    console.log("file : ", file)
      if (!file) return;
  
      // Validate MP4 format
      if (file.type !== "video/mp4") {
        toast(<AlertError message="Only MP4 files are allowed!" />);
        return;
      }

      if (file.size > 100 * 1024 * 1024) { // 100MB limit
        toast(<AlertError message="Video must be under 100MB!" />);
        return;
      }
  
      const fileName = `doctor/${_id}/videos/${Date.now()}-${file.name}`;
      const res = seUploadFun(file, fileName);
    console.log("fileName : ", fileName)

    // const res = '';
  
      res
        .then((result) => {
          if (result && result.key) {
            const { data, errors } = this.state;
            errors.video = "";
            data.video = result.key;
            this.setState({ data, errors });
            toast(<AlertSuccess message="Video uploaded successfully!" />);
          }
        })
        .catch(() => {
          toast(<AlertError message="Failed to upload video!" />);
        });
    };

    removeVideo = () => {
      const { data, errors } = this.state;
      data.video = "";
      errors.video = "";
      this.setState({ data, errors });
      // toast(<AlertSuccess message="Video removed successfully!" />);
    };    
  
    doSubmit = () => {
      const { instagram, linkedin, video } = this.state.data;
      const data = {
        social_links: {
          instagram,
          linkedin,
          video: video || "", 
        },
      };
  
      if (!this.state.loading) {
        this.setState({ btnClass: "btn btn-primary btn-lg disabled", loading: true });
        this.props.doctorUpdate(data, this.callBack);
      }
    };
  
    callBack = (res) => {
      this.setState({ btnClass: "btn btn-primary btn-lg", loading: false });
      if (res.status === 200) {
        this.props.history.push("/doctor/sign-up/contract");
        toast(<AlertSuccess message="Profile updated successfully!" />);
        this.props.loadDoctorProfile();
      } else {
        toast(<AlertError message="Failed to update profile!" />);
      }
    };
  
    componentDidMount = () => {
      if (getDoctorToken("auth")) {
        this.props.loadDoctorProfile();
      } else {
        this.props.history.push("/doctor/sign-up/personal-detail");
      }
    };
  
    componentDidUpdate = (prevProps) => {
      if (!this.props.profileLoading && this.props.profileLoading !== prevProps.profileLoading) {
        const { instagram = "", linkedin = "", video = "" } = this.props.doctorProfile.social_links || {};
        this.setState({ data: { instagram, linkedin, video: video } });
      }
    };
  
    render() {
      return (
        <React.Fragment>
          <SignUpLeftBar />
          <div className="main-container">
            <div className="main-head">
              <button className="nav-toggler" onClick={this.changeBodyClass}>
                <i className="fas fa-bars"></i>
              </button>
              <a href="#" className="brand-logo">
                <img src="include/images/yes-mindy-logo.svg" alt="" />
              </a>
            </div>
            <HelpText />
            <div className="container ml-0">
              <div className="main-heading">
                <h1>Social Links</h1>
              </div>
              <form onSubmit={this.handleSubmit}>
                <div className="main-content">
                  <div className="row">
                    <div className="col-xl-10">
                      {this.renderInput("instagram", "Instagram Profile Link", "text")}
                      {this.renderInput("linkedin", "LinkedIn Profile Link", "text")}
                    </div>
                  </div>
  
                   {/* Video Upload  */}
                  <div className="row">
                    <div className="col-xl-6">
                      <FileInput
                        totalUploaded={this.state.data["video"]}
                        error={this.state.errors["video"]}
                        label="Doctor Profile Video (MP4, Under 100MB)"
                        name="video"
                        status="Add Video"
                        onchange={this.fileUploadVideo}
                        text={this.state.data["video"]}
                      />
                    </div>
                    {this.state.data.video && (
                    <div className="col-xl-2">
                        <a
                          href="#"
                          className="add-more-field m-0 errorLabel"
                          onClick={(e) => { 
                            e.preventDefault(); 
                            this.removeVideo();
                        }}
                        >
                          - Remove
                        </a>
                      </div>
                    )}
                  </div>
  
                  {/* {this.state.data.video && (
                    <div className="row">
                      <div className="col-xl-6">
                        <video width="300" height="200" controls  disablePictureInPicture controlsList="nodownload nofullscreen noremoteplayback" >
                          <source src={process.env.REACT_APP_S3URL + this.state.data.video} type="video/mp4" />
                        </video>
                      </div>
                    </div>
                  )} */}
  
                  <div className="row">
                    <div className="col-xl-5">
                      <div className="form-group">
                        <SubmitBtn label="Save & Continue" loading={this.state.loading} btnClass={this.state.btnClass} />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </React.Fragment>
      );
    }
  }
  

const mapStateToProps = (state) => ({
  profileLoading: getDoctor(state).profileLoading,
  doctorProfile: getDoctor(state).profile,
});

const mapDispatchToProps = (dispatch) => ({
  doctorUpdate: (data, callback) => dispatch(doctorUpdate(data, callback)),
  loadDoctorProfile: () => dispatch(loadDoctorProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SocialLinks);
